module.exports = __webpack_public_path__ + "ee71d4aa505a39d826253d4f09da9ae8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/gabelli.png
// module id = 1788
// module chunks = 0